import { useMemo } from 'react';
import { useSnapshot } from 'valtio';
import { IntelligenceSectionTitle } from '../common';
import { jurisdictionalIntersectionLayerIds } from '../common/config';
import { getRollupCount } from '../common/getRollupCount';
import IntelligenceSection from '../common/IntelligenceSection';
import Table from '../common/Table';
import store from '../store';

export default function JurisdicitonalIntersections() {
  const { config } = useSnapshot(store) as typeof store;

  const featureCount = useMemo(() => getRollupCount(config, jurisdictionalIntersectionLayerIds), [config]);

  return (
    <IntelligenceSection title={IntelligenceSectionTitle.JurisdictionalIntersections} featureCount={featureCount}>
      <Table
        label="Cities"
        columns={['Overlap Percentage', 'City']}
        rows={[
          {
            layerId: 'incorporatedPlaces',
            columnProperties: ['overlap', 'NAME'],
          },
        ]}
        sortBy="NAME"
        emptyMessage="No known cities in the project area"
      />

      <Table
        label="Counties"
        columns={['Overlap Percentage', 'County']}
        rows={[{ layerId: 'county', columnProperties: ['overlap', 'County'] }]}
        sortBy="County"
        // this should never happen
        emptyMessage="No known counties in the project area."
      />

      <Table
        label="State DOT Districts"
        columns={['Overlap Percentage', 'District', 'State']}
        rows={[
          {
            layerId: 'landUseTransportationDistrictBoundaries',
            columnProperties: ['overlap', 'DISTRICT', 'state'],
          },
        ]}
        sortBy="DISTRICT"
        // this should never happen
        emptyMessage="No known state DOT districts in the project area."
      />
    </IntelligenceSection>
  );
}
